import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Resolution from 'engine/Resolution.js';

const BASE_RESOLUTION = new Resolution(32, false);

const Bars = ({
    numberOfSteps,
    setSelectedBar,
    selectedBar,
    resolution,
    isFollowing,
    setIsFollowing,
    patternStep,
    barLength
}) => { 
    let numBars = Math.floor(numberOfSteps / barLength);
    if (isNaN(numBars)) {
        numBars = 1;
    }
    let arr = Array(numBars).fill(1);
    let start = barLength * selectedBar;
    let end = barLength * (selectedBar + 1);

    useEffect(() => {
        if (patternStep >= start && patternStep < end) {
        } else if (!isNaN(patternStep) && isFollowing) {
            let _barLength = Math.floor(patternStep / barLength);
            setSelectedBar(_barLength);
        }
    }, [patternStep, start, end, setSelectedBar, barLength, isFollowing]);


    if (numBars === 1) {
        return [];
    }
    return (
        <div className="bars">
          <div className="bar-label">
            Bar: 
          </div>
          {arr.map(
              (x, i) =>
                  <Bar
                    bar={i}
                    isSelected={selectedBar === i}
                    onClick={() => {
                        setSelectedBar(i);
                        setIsFollowing(false);
                    }}
                  />)}
          <div
            onClick={() => setIsFollowing(!isFollowing)}
            className={isFollowing ? "following follow-btn" : "follow-btn"}>
            FOLLOW
          </div>
        </div>
    );
}

const Bar = ({bar, isSelected, onClick}) => {
    let className = "bar";
    if (isSelected) {
        className += " selected";
    }
    return (
        <div
          onClick={onClick}
          className={className}>
          {bar+1}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let resolution = state.sequencer.displayResolution;
    let trackStep = props.track.sequencerEngine.trackStep;
    let patternStep = Math.floor(resolution.transformStepAtResolution2(
        props.track.getPatternStep(trackStep),
        BASE_RESOLUTION));

  return {
      patternStep: patternStep,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Bars);
